var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGpsLarge = function SvgGpsLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "gpsLarge_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gpsLarge_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M12 21.45a.5.5 0 0 1-.362-.137.5.5 0 0 1-.137-.362V20q-3.126-.3-5.162-2.337Q4.3 15.626 4 12.5h-.95q-.224 0-.362-.15A.5.5 0 0 1 2.55 12a.5.5 0 0 1 .138-.363.5.5 0 0 1 .362-.137H4q.3-3.126 2.338-5.163Q8.376 4.3 11.5 4v-.95q0-.225.15-.363A.5.5 0 0 1 12 2.55q.224 0 .363.137a.5.5 0 0 1 .137.363V4q3.125.3 5.163 2.337Q19.7 8.376 20 11.5h.95q.224 0 .362.15a.5.5 0 0 1 .138.35.5.5 0 0 1-.138.363.5.5 0 0 1-.362.137H20q-.3 3.125-2.337 5.163Q15.626 19.7 12.5 20v.95q0 .224-.15.362a.5.5 0 0 1-.35.138M12 19q2.901 0 4.95-2.05T19 12q0-2.9-2.05-4.95T12 5 7.05 7.05 5 12t2.05 4.95T12 19m0-4a2.9 2.9 0 0 1-2.124-.874A2.9 2.9 0 0 1 9 12q0-1.25.875-2.125A2.9 2.9 0 0 1 12 9q1.25 0 2.125.875Q15 10.75 15 12t-.875 2.125A2.9 2.9 0 0 1 12 15m0-1q.825 0 1.414-.587Q14 12.825 14 12q0-.825-.587-1.413A1.93 1.93 0 0 0 12 10q-.825 0-1.412.587A1.93 1.93 0 0 0 10 12q0 .824.588 1.412Q11.176 14 12 14"
  }))));
};
export default SvgGpsLarge;